import { TbHelpCircle } from 'react-icons/tb'

const helpGroups = [
  {
    title: 'Pedido e atendimento',
    items: [
      ['Preço mínimo para entrega', 'Define o valor mínimo que o cliente precisa atingir para solicitar uma entrega.'],
      ['Ativar retirada', 'Permite que o cliente faça o pedido pelo cardápio e escolha retirá-lo no estabelecimento.'],
      ['Ativar avaliação', 'Solicita ao cliente uma avaliação depois que o pedido for finalizado.'],
      ['Som de novo pedido', 'Reproduz um alerta sonoro quando um novo pedido chegar.']
    ]
  },
  {
    title: 'Aceite automático',
    items: [
      ['Pedido do iFood', 'Aceita automaticamente os novos pedidos recebidos pela integração com o iFood.'],
      ['Produto', 'Aceita automaticamente produtos que dependam de confirmação durante o atendimento do pedido.']
    ]
  },
  {
    title: 'Impressão automática',
    items: [
      ['Mesa, delivery e balcão', 'Imprime automaticamente os pedidos desses tipos quando a opção correspondente estiver ativa.'],
      ['Pedido do iFood', 'Imprime os pedidos recebidos pela integração com o iFood.'],
      ['Novo pedido', 'Dispara a impressão assim que um novo pedido chegar.'],
      ['Produtos adicionados', 'Imprime somente os novos produtos incluídos quando um pedido for alterado.'],
      ['Produto removido ou cancelado', 'Imprime um aviso quando um produto for removido ou cancelado.'],
      ['Pedido cancelado', 'Imprime um aviso quando o pedido inteiro for cancelado.']
    ]
  },
  {
    title: 'Aplicativo e impressora',
    items: [
      ['Baixar configurador', 'Instala no computador o aplicativo necessário para enviar os pedidos à impressora.'],
      ['Impressora padrão', 'Escolhe em qual impressora deste computador os pedidos serão impressos.'],
      ['Computador padrão', 'Define este computador como o responsável pelas impressões automáticas da loja.'],
      ['Mensagem da impressão', 'Adiciona uma mensagem personalizada ao comprovante impresso.']
    ]
  }
]

export function ConfigurationHelp() {
  return (
    <div className="modal fade admin-form-modal company-settings-help" id="configurationHelp" tabIndex="-1" aria-labelledby="configurationHelpLabel" aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header company-settings-help-header">
            <div>
              <span><TbHelpCircle size={22} /></span>
              <div>
                <h5 className="modal-title" id="configurationHelpLabel">Ajuda: pedido e impressão</h5>
                <p>Entenda o que cada configuração altera no funcionamento da loja.</p>
              </div>
            </div>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
          </div>
          <div className="modal-body">
            <div className="company-settings-help-grid">
              {helpGroups.map(group => (
                <section className="company-settings-help-group" key={group.title}>
                  <h6>{group.title}</h6>
                  <dl>
                    {group.items.map(([term, description]) => (
                      <div key={term}>
                        <dt>{term}</dt>
                        <dd>{description}</dd>
                      </div>
                    ))}
                  </dl>
                </section>
              ))}
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="admin-primary-button" data-bs-dismiss="modal">Entendi</button>
          </div>
        </div>
      </div>
    </div>
  )
}
